<template>
  <div>
    <BannerCarousel />

    <div class="content-wrapper">
      <el-row :gutter="0" >
        <el-col :span="5" class="category-container">
          <el-row>
            <el-col :span="24" class="classify">
              <CategoryMenu @selectCategory="onCategorySelected"/>
            </el-col>
            <el-col v-if="rankingList.length" :span="24" class="rank">
              <div class="rank_title">销量排行</div>
              <ul class="rank_row_info">
                <li v-for="(item, index) in rankingList" :key="index" @click="goItemDetail(item)">
                  <div class="rank_img_box">
                    <img :src="getItemUrl(item.itemImageUri)" class="rank_img">
                  </div>
                  <div class="rank_info">
                    <div :title="item.itemName" class="ellipsis">{{ item.itemName }}</div>
                    <!-- <div>价格：￥
                      <span v-if="inPromotion(item)" class="price-number">{{ item.promotionPrice }}</span>
                      <span v-else class="price-number">{{ item.itemPrice }}</span>元
                    </div> -->
                    <div class="rank_qty">销量：{{ item.purchaseQuantity | toThousandslsFilter }}</div>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="19">
          <QueryCondition :query-info="queryInfo" @change="onConditionChange" />
          <el-row class="order-container">
            <el-button type="text" class="order-btn" @click="setOrder('sold_qty')">
              销量
              <i v-if="getOrderIndicator('sold_qty','asc')" class="el-icon-arrow-up el-icon--right"/>
              <i v-if="getOrderIndicator('sold_qty','desc')" class="el-icon-arrow-down el-icon--right"/>
            </el-button>
            <el-button type="text" class="order-btn" @click="setOrder('item_price')">
              价格
              <i v-if="getOrderIndicator('item_price','asc')" class="el-icon-arrow-up el-icon--right"/>
              <i v-if="getOrderIndicator('item_price','desc')" class="el-icon-arrow-down el-icon--right"/>
            </el-button>
            <el-button type="text" class="order-btn" @click="setOrder('publish_date')">
              上架时间
              <i v-if="getOrderIndicator('publish_date','asc')" class="el-icon-arrow-up el-icon--right"/>
              <i v-if="getOrderIndicator('publish_date','desc')" class="el-icon-arrow-down el-icon--right"/>
            </el-button>
          </el-row>
          <div v-if="itemList.length">
            <el-row v-loading="listLoading" class="list-container">
              <el-col v-for="item in itemList" :key="item.itemId" :span="6" >
                <div class="item-box">
                  <div v-if="item.isHot" class="is-hot">热销</div>
                  <div v-if="item.activityFlag" class="item-activity">
                    <img src="@/assets/images/activity/activity-icon.png">
                  </div>
                  <div class="item-image">
                    <router-link :to="{name: 'item-info', params: {itemId: item.itemId}}" target="_blank" rel="opener">
                      <img :src="getImageUrl(item)">
                    </router-link>
                  </div>
                  <div class="item-name ellipsis">
                    <router-link :to="{name: 'item-info', params: {itemId: item.itemId}}" :title="item.itemName" target="_blank" rel="opener">{{ item.itemName }}</router-link>
                  </div>
                  <div :title="item.preShipDate" class="delivery-info ellipsis">{{ item.preShipDate }}</div>
                  <div class="item-price">
                    ￥
                    <span v-if="inPromotion(item)" class="price-number">{{ item.promotionPrice | toThousandslsFilter }}</span>
                    <span v-else class="price-number">{{ item.itemPrice | toThousandslsFilter }}</span>
                    元
                  </div>
                  <div class="item-qty">
                    <el-input-number v-model="item.buyQty" :min="item.minQty" :max="item.maxQty" :step="item.stepQty" size="mini"/>
                  </div>
                  <div class="item-qty">
                    <span v-if="item.isPreOrder !== 1" class="available-qty">可售: {{ item.availableQty || 0 }}</span>
                    <span v-else class="available-qty">已预订: {{ item.soldQty | toThousandslsFilter }}</span>
                  </div>
                  <div class="item-buy">
                    <el-button type="default" size="mini" class="buy-btn" @click="addToCart(item)">加入购物车</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="item-pagination">
              <el-pagination
                :current-page="queryParam.page"
                :page-size="queryParam.pageSize"
                :total="total"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"/>
            </div>
          </div>
          <div v-else class="no-data">
            当前没有商品信息
          </div>
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import itemApi from '@/api/item'
import baseApi from '@/api/base'
import { commonUtils } from '@/utils/common'
import CategoryMenu from './components/category-menu'
import QueryCondition from './components/query-condition'
import BannerCarousel from '@/views/components/banner-carousel'
export default {
  name: 'ItemList',
  components: {
    CategoryMenu,
    QueryCondition,
    BannerCarousel
  },
  data() {
    return {
      queryInfo: {
        category: null,
        abiBrand: null,
        priceSection: null,
        keyword: null
      },
      queryParam: {
        page: 1,
        pageSize: 12,
        dealerCategoryId: '',
        abiBrandId: '',
        minPrice: '',
        maxPrice: '',
        orderCol: '',
        orderMethod: '',
        keyword: ''
      },
      total: null,
      listLoading: false,
      itemList: [],
      rankingList: [],
      limitRankNum: 5,
      defaultImage: require('../../assets/images/image-not-found.png')
    }
  },
  computed: {
    ...mapGetters([
      'isDealerClient'
    ])
  },
  mounted() {
    this.init()
  },
  beforeRouteUpdate (to, from, next) {
    this.setKeyword(to.query.keyword).then(() => {
      return this.setQueryAbiBrand(to.query.abiBrandId)
    }).then(() => {
      this.queryItemList()
    })
    next()
  },
  methods: {
    init() {
      const abiBrandId = this.$route.query.abiBrandId
      const keyword = this.$route.query.keyword
      this.setKeyword(keyword).then(() => {
        return this.setQueryAbiBrand(abiBrandId)
      }).then(() => {
        this.queryItemList()
      })
      // 销量排行
      this.queryRankingList()
    },
    queryItemList() {
      this.queryParam.dealerCategoryId = this.queryInfo.category ? this.queryInfo.category.categoryId : ''
      this.queryParam.abiBrandId = this.queryInfo.abiBrand ? this.queryInfo.abiBrand.abiBrandId : ''
      this.queryParam.minPrice = this.queryInfo.priceSection ? this.queryInfo.priceSection.priceFrom : ''
      this.queryParam.maxPrice = this.queryInfo.priceSection ? this.queryInfo.priceSection.priceTo : ''
      this.queryParam.keyword = this.queryInfo.keyword
      this.listLoading = true
      itemApi.queryItemList(this.queryParam).then(response => {
        this.listLoading = false
        if (response.data.resultCode === '0') {
          const itemList = response.data.resultData.itemList
          this.total = response.data.resultData.pageInfo.totalCounts
          itemList.map(item => {
            item.buyQty = item.moqmultiple ? item.moqmultiple : 1
            item.stepQty = item.moqmultiple ? item.moqmultiple : 1
            item.minQty = item.moqmultiple ? item.moqmultiple : 1
            item.maxQty = item.isPreOrder === 1 ? Infinity : (parseInt(item.availableQty/item.stepQty) * item.stepQty)
          })
          this.itemList = itemList
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    queryRankingList() {
      itemApi.getPurchaseRanking().then(response => {
        if (response.data.resultCode === '0') {
          const rankingList = response.data.resultData.rankingList || []
          this.rankingList = rankingList.slice(0, this.limitRankNum)
        }
      })
    },
    setQueryAbiBrand(brandId) {
      return new Promise((resolve, reject) => {
        if (brandId) {
          baseApi.queryAbibrandInfo(brandId).then(response => {
            if (response.data.resultCode === '0') {
              this.queryInfo.abiBrand = response.data.resultData.brandInfo || null
            }
            resolve()
          }).catch(error => {
            reject(error)
          })
        } else {
          this.queryInfo.abiBrand = null
          resolve()
        }
      })
    },
    setKeyword(keyword) {
      return new Promise((resolve) => {
        this.queryInfo.keyword = keyword ? keyword : null
        resolve()
      })
    },
    onCategorySelected(val) {
      this.queryInfo.category = val || null
      this.queryItemList()
    },
    onConditionChange(data) {
      this.queryInfo = data.queryInfo
      this.queryItemList()
    },
    setOrder(orderCol) {
      if (this.queryParam.orderCol === orderCol) {
        this.$set(this.queryParam, 'orderMethod', (this.queryParam.orderMethod && this.queryParam.orderMethod === 'asc') ? 'desc' : 'asc')
      } else {
        this.$set(this.queryParam, 'orderCol', orderCol)
        this.$set(this.queryParam, 'orderMethod', 'asc')
      }
      this.queryItemList()
    },
    getOrderIndicator(orderCol, orderMethod) {
      return this.queryParam.orderCol === orderCol && this.queryParam.orderMethod === orderMethod
    },
    getImageUrl(item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    inPromotion(item) {
      return item.promotionPrice && item.promotionPrice > 0
    },
    handleCurrentChange(val){
      this.queryParam.page = val
      this.queryItemList()
    },
    addToCart(item) {
      if (item.isPreOrder !== 1 && item.buyQty > item.availableQty) {
        this.$message.error('购买数量超过可售数量')
      }
      if (item.buyQty % item.stepQty !== 0) {
        this.$message.error('购买数量应为订购倍数的整数倍')
        return
      }
      const cartItem = {
        itemId: item.itemId,
        itemQty: item.buyQty
      }
      this.$store.dispatch('AddCartItem', cartItem).then(() => {
        this.$message.success('商品添加购物车成功')
      }).catch(() => {
        this.$message.error('商品添加购物车失败')
      })
    },
    getItemUrl(imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    goItemDetail(item) {
      let routeData = this.$router.resolve({ name: 'item-info', params: { itemId: item.itemId } })
      window.open(routeData.href, '_blank')
    },
    toAct(){
      this.$router.push('/event/act')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
$color-darkred: #88000C;
.order-container {
  background: linear-gradient(to top,  #92171A, $color-darkred);
  color: #ffffff;
  padding-left: 20px;
  .order-btn {
    width: 100px;
    color: #fff;
  }
}
.list-container {
  background: $base-red;
  padding: 7px 5px 10px;
  margin-bottom: 20px;

  .item-box {
    position: relative;
    margin: 0px auto 10px auto;
    width: 200px;
    height: 350px;
    overflow: hidden;
    padding: 5px 10px;
    vertical-align: middle;
    text-align: center;
    background: #FFF;
    font-size: 12px;
    .is-hot {
      position: absolute;
      top: 0;
      left: 0;
      width: 40px;
      height: 26px;
      line-height: 26px;
      background: #FF9C01;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }
    .item-activity {
      position: absolute;
      top: 4px;
      right: 10px;
      width: 45px;
      height: 57.4px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .item-image {
      width: 180px;
      height: 170px;
      overflow: hidden;
      margin: 0 auto;
      vertical-align: middle;
      img {
        max-width: 100%;
        max-height: 150px;
        margin: auto;
      }
    }
    .item-name {
      color: #666;
      height: 14px;
      margin-top: 10px;
    }
    .delivery-info {
      color: $base-red;
      height: 18px;
      line-height: 18px;
      margin: 6px 5px;
      overflow: hidden;
    }
    .item-price {
      color: #E4393C;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 10px;
      .price-number {
        font-size: 16px;
      }
    }
    .item-qty {
      text-align: center;
      padding-left: 10px;
      margin-bottom: 10px;
      .el-input-number--mini {
        width: 110px;
      }
      .el-input-number--mini .el-input__inner {
        padding-left: 10px;
        padding-right: 10px;
      }
      .available-qty {
        margin-left: 5px;
        color: green;
      }
    }
    .item-buy {
      margin-top: 5px;
      .buy-btn {
        background-color: #FF9C01;
        color: #fff;
        border: 0px;
        width: 160px;
        height: 30px;
      }
      .buy-btn:focus {
        outline: none;
        border: 0px;
      }
    }
  }
}
.item-pagination {
  text-align: right;
  /deep/ .el-pager li.active {
    color: $base-red;
  }
  // /deep/ .el-pager li:hover {
  //   color: $base-red;
  // }
}
.classify {
  margin-left: -15px;
}
.rank {
  width: 220px;
  margin: 15px 0 15px 0;
  font-size: 14px;
  .rank_title {
    height: 40px;
    // border-bottom: 1px solid #92171A;
    padding-left: 15px;
    background: #92171A;
    color: #fff;
    line-height: 40px;
  }
}
.rank_row_info {
  border: 1px solid #92171A;
  li {
    display: flex;
    align-items: center;
    padding: 0 4px;
    height: 82px;
    border-bottom: 1px solid #92171A;
    font-size: 12px;
    cursor: pointer;
    &:last-child {
      border: none;
    }
  }
  .rank_info {
    flex-basis: 146px;
    padding-left: 10px;
    overflow: hidden;
  }
  .rank_img_box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 100%;
  }
  .rank_img {
    max-width: 60px;
    max-height: 80px;
  }
  .rank_qty {
    color: #92171A;
    margin-top: 6px;
  }
}

</style>
